export default {
    current: 0
}